import {
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";
const iconStyle = {
  width: "62px",
  height: "62px",
  borderRadius: "50px",
  background:
    "radial-gradient(68.29% 68.29% at 50% 50%, #73246C 0%, #1A103B 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

function CustomDrawer() {
  const [anchorEl, setanchorEl] = useState(null);
  const [Awidth, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    console.log(window.innerWidth);
    //   const handleResize = () => {
    //     setWidth(window.innerWidth);
    //   };
    //   window.addEventListener("resize", handleResize);
  }, []);

  // Drawer top
  const [state, setState] = useState({
    top: true,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchorEl, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchorEl]: open });
  };

  const list = (anchorEl) => (
    <Box
      sx={{
        background:
          "radial-gradient(68.29% 68.29% at 50% 50%, #73246C 0%, #1A103B 100%)",
        width: `250px`,
      }}
      minHeight="100%"
      role="presentation"
      onClick={toggleDrawer(anchorEl, false)}
      onKeyDown={toggleDrawer(anchorEl, false)}
    >
      <List>
        {[
          <Box
            mt="50px"
            smooth
            py="30px"
            to="/#mission"
            display="flex"
            alignItem="centre"
            justifyContent="center"
            style={{ textDecoration: "none", color: "white" }}
            fontSize="40px"
          >
            <Link to="/" style={{ textDecoration: "none" }}>
              <IconButton>
                {" "}
                <Box
                  sx={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#FAA631",
                    "&:hover": {
                      color: "white",
                    },
                    "&:active": {
                      color: "white",
                    },
                    fontFamily: "semi",
                  }}
                >
                  DASHBORD
                </Box>{" "}
              </IconButton>
            </Link>
          </Box>,
          <Box
            smooth
            to="/#roadmap"
            display="flex"
            py="30px"
            alignItem="centre"
            justifyContent="center"
            style={{ textDecoration: "none", color: "white" }}
            fontSize="40px"
          >
            <Link to="/store" style={{ textDecoration: "none" }}>
              <IconButton>
                <Box
                  sx={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#FAA631",
                    "&:hover": {
                      color: "white",
                    },
                    "&:active": {
                      color: "white",
                    },
                    fontFamily: "semi",
                  }}
                >
                  STORE
                </Box>{" "}
              </IconButton>
            </Link>
          </Box>,
          <Box
            smooth
            to="/#roadmap"
            display="flex"
            py="30px"
            alignItem="centre"
            justifyContent="center"
            style={{ textDecoration: "none", color: "white" }}
            fontSize="40px"
          >
            <Link to="/stake" style={{ textDecoration: "none" }}>
              <IconButton>
                <Box
                  sx={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#FAA631",
                    "&:hover": {
                      color: "white",
                    },
                    "&:active": {
                      color: "white",
                    },
                    fontFamily: "semi",
                  }}
                >
                  STAKE
                </Box>{" "}
              </IconButton>
            </Link>
          </Box>,
          ,
        ].map((text, index) => (
          <ListItem
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            button
            key={text}
          >
            <Box
              fontFamily="Josefin Sans"
              fontSize="20px"
              width="100%"
              sx={{ cursor: "pointer" }}
              color="white"
            >
              {text}
            </Box>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <IconButton
        onClick={toggleDrawer(anchorEl, true)}
        sx={{ marginTop: "20px" }}
      >
        {" "}
        <MenuIcon sx={{ color: "white", fontSize: "30px" }} />
      </IconButton>

      <Drawer
        // sx={{ maxWidth: "500px", width: "100%" }}
        className="drawer"
        anchorEl={anchorEl}
        open={state[anchorEl]}
        onClose={toggleDrawer(anchorEl, false)}
      >
        {list(anchorEl)}
      </Drawer>
    </>
  );
}

export default CustomDrawer;
